import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function StickyHeaderController() {
  const token = useSelector((state) => state.userSession?.token);
  const isAuthenticated = !!token;

  useEffect(() => {
    const header: HTMLElement = document.querySelector('header.header-wrapper');
    const contentArea: HTMLElement = document.querySelector(
      'div.ui.basic.segment.content-area',
    );
    const toolbar: HTMLElement = document.querySelector('div#toolbar');
    if (!header || !contentArea) return;

    const setPadding = () => {
      contentArea.style.paddingTop = `${header.offsetHeight}px`;
      header.style.marginLeft = isAuthenticated
        ? `${toolbar.offsetWidth / 2}px`
        : '';
    };

    setPadding();

    const resizeObserver = new ResizeObserver(setPadding);
    resizeObserver.observe(header);
    if (toolbar) resizeObserver.observe(toolbar);

    return () => resizeObserver.disconnect();
  }, [isAuthenticated]);

  return null;
}
